<template>
  <div class="add-question">
    <pageTitle :pageTitle="`${title}${$t('lang.k_314001')}`">
      <!-- <div class="headBtnGroup">
        <vh-button type="text" @click="openSet" class="name_set_button">
          修改「表单」显示名称
        </vh-button>
        <i class="iconfont-v3 saasicon_help_m" @click="showPreview"></i>
      </div> -->
    </pageTitle>
    <question
      ref="questions"
      :alias="alias"
      :addTitle="$t('lang.k_314002')"
      :isPlayBackSet="false"
    ></question>

    <!-- 别名设置弹框 -->
    <VhallDialog
      :title="$t('lang.k_314003')"
      :visible.sync="dialogNameSet"
      :close-on-click-modal="false"
      class="zdy-async-dialog"
      width="400px"
    >
      <div class="async__body">
        <div class="async__ctx">
          <vh-input
            v-model="alias"
            :placeholder="$t('lang.k_314004')"
            maxlength="8"
            v-clearEmoij
            show-word-limit
          ></vh-input>
          <p class="setname_tip">{{ $t('lang.k_314005') }}</p>
        </div>
        <div class="async__footer">
          <vh-button type="info" plain size="medium" @click="saveNewName('cancel')" round>
            {{ $t('lang.k_314006') }}
          </vh-button>
          <vh-button type="primary" size="medium" @click="saveNewName" round>
            {{ $t('lang.k_314007') }}
          </vh-button>
        </div>
      </div>
    </VhallDialog>
    <!-- 图列展示弹框 -->
    <VhallDialog
      :visible.sync="dialogPreview"
      :modalClick="true"
      :show-close="true"
      class="zdy-dialog"
      width="740px"
    >
      <div class="img_base">
        <img src="@/views/LiveModule/MaterialSet/images/Q_preview.png" alt="" />
      </div>
    </VhallDialog>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  import question from '@/components/Question/question';
  export default {
    data() {
      return {
        alias: '',
        dialogNameSet: false,
        dialogPreview: false
      };
    },
    components: {
      PageTitle,
      question
    },
    name: 'addQuestion.vue',
    computed: {
      title() {
        if (this.$route.query.questionId) {
          return this.$t('lang.k_314008');
        } else {
          return this.$t('lang.k_314009');
        }
      }
    },
    methods: {
      showPreview() {
        this.dialogPreview = true;
        console.log('%c 展示例图', 'color:blue');
      },
      openSet() {
        this.dialogNameSet = true;
        // 资料管理 - 被同步后的数据，编辑的时候反显
        this.alias = this.alias || this.$route.query.alias || this.$t('lang.k_314001');
        console.log('%c 打开别名设置弹框', 'color:blue');
      },
      saveNewName(data) {
        this.dialogNameSet = false;
        if (data == 'cancel') {
          this.alias = this.$route.query.alias || this.$t('lang.k_314001');
        }
        console.log(this.$route.query);
      }
    }
  };
</script>

<style lang="less" scoped>
  #settingBox /deep/ .control-area {
    width: 185px;

    .categroys {
      border-bottom: 1px dashed #fb3a32;
      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .headBtnGroup {
    float: right;
    .name_set_button {
      margin-right: 8px;
      color: #3562fa;
    }
  }
</style>
<style lang="less">
  .add-question .zdy-dialog {
    .img_base {
      padding: 4px;
      border-radius: 4px;
      background: #000;
      img {
        width: 100%;
      }
    }
  }
  .setname_tip {
    margin-top: 10px;
    color: #666 !important;
  }
</style>
